// extracted by mini-css-extract-plugin
module.exports = {"container":"similar-in-price-items_container__Ep8u8"};